// extracted by mini-css-extract-plugin
module.exports = {"a1perbvc":"a1perbvc","full-bleed":"full-bleed"};